"use client";
import clsx from "clsx";
import { FC } from "react";
import MiniCart from "@/components/Cart/MiniCart/MiniCart";
import useStoreKeys from "@/hooks/useStoreKeys";
import { useHeader } from "../hooks/useHeader";
import { CategoryTree } from "@/lib/5874/types";
import { HeaderStoreBuilderContent } from "../headerTypes";
import HeaderBurgerButton from "../HeaderBurgerButton/HeaderBurgerButton";
import HeaderLogo from "../HeaderLogo/HeaderLogo";
import LoginModal from "./LoginModal/LoginModal";
import { useSearchParams } from "next/navigation";
import Nav from "./Nav/Nav";
import SearchBar from "./SearchBar/SearchBar";
import styles from "./Header.module.scss";
import Modal from "@/components/Modal/Modal";
import RegionWebsiteSelectorModal from "@/components/LocalWebsiteSelector/RegionSelectorModal";
import useRegionDropdownData from "@/hooks/useRegionDropdownData";
import StoreIndicator from "./StoreIndicator/StoreIndicator";
import useMediaQuery from "@/hooks/useMediaQuery";

interface HeaderProps {
	bigCommerceMenu: CategoryTree[];
	builderMenuContent: HeaderStoreBuilderContent;
	accountAreaConfig?: any;
}

const Header: FC<HeaderProps> = ({
	bigCommerceMenu,
	builderMenuContent,
	accountAreaConfig,
}) => {
	const { openMobileMenu, handleOpenMobileMenu } = useHeader();
	const { regionDropdowns, toggleModal, closeModal } = useRegionDropdownData();
	const { store, lang } = useStoreKeys();
	const { isDesktop } = useMediaQuery();

	const searchParams = useSearchParams();
	const isModalOpen = searchParams.has("showModal");

	const storeIndicatorProps = {
		store: store ?? "global",
		lang,
		onClickHandler: toggleModal,
	};

	return (
		<header className={styles.header}>
			<div className={clsx([styles.layout])}>
				<div className={styles.top}>
					<div className={styles.burgerAndLogo}>
						<HeaderBurgerButton
							isOpen={false}
							onButtonClick={() => handleOpenMobileMenu(true)}
							ariaLabel={"Open main navigation menu"}
						/>
						<HeaderLogo
							url={builderMenuContent.logo?.url}
							altText={builderMenuContent.logo?.altText}
							href={`/${store}/${lang}`}
						/>
					</div>
					<SearchBar
						placeHolderText={builderMenuContent.searchBar?.text}
						ariaLabel={builderMenuContent.searchBar?.ariaLabel}
						className={styles.search}
					/>
					<div className={styles.loginAndCart}>
						{isDesktop ? (
							<StoreIndicator
								store={store}
								lang={lang}
								onClickHandler={toggleModal}
							/>
						) : null}
						<LoginModal accountAreaConfig={accountAreaConfig} />
						<MiniCart />
					</div>
				</div>
				<Nav
					bigCommerceMenu={bigCommerceMenu}
					builderMenuContent={builderMenuContent}
					openMobileMenu={openMobileMenu}
					setOpenMobileMenu={handleOpenMobileMenu}
					storeIndicatorProps={storeIndicatorProps}
				/>
			</div>
			<Modal
				isOpen={isModalOpen}
				toggleModal={closeModal}
				contentClassName={styles.modalContent}
				modalBackground='light'
			>
				<RegionWebsiteSelectorModal regionDropdowns={regionDropdowns} />
			</Modal>
		</header>
	);
};

export default Header;
